// this area doesn't have a navigation item in the navbar

import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { PulseIcon } from '@moia-dev/pace-icons'

// Exported for the area config even though this area has no navbar item, so the
// generated index stays consistent with every other area.
export const StatusAreaNavigationIcon = PulseIcon

export const StatusAreaNavigation = (_props: AreaNavigationProps) => {
  return null
}
